<div class="documentation-org-chart content">
  <div class="card">
    <div class="documentation-org-chart_title">{{'CORE_ORG_CHART' | translate}}</div>
  </div>
  <div class="card" *ngIf="isDesktop; else onlyDesktopAlert">
    <div class="row">
      <div class="col-12 mb-5">
        <div class="bold mb-2">ORGANIZATION CHART</div>
        <div>
          <si-org-chart [model]="orgChartModel">
            <p-organizationChart styleClass="documentation-org-chart_org-chart">
              <ng-template let-node pTemplate="person">
                <div class="node-header">{{node.data.label}}</div>
                <div class="node-content">
                  <div>{{node.data.name}}</div>
                </div>
              </ng-template>
              <ng-template let-node pTemplate="default">
                {{node.data.label}}
              </ng-template>
            </p-organizationChart>
          </si-org-chart>
        </div>
      </div>
    </div>
  </div>
  <ng-template #onlyDesktopAlert>
    <div class="card">
      <div>{{'CORE_COMPONENT_ONLY_IN_DESKTOP' | translate}}</div>
    </div>
  </ng-template>
</div>
